<!-- @format -->
<keyphrase-modal>
  <style>
    .wrap {
      display: flex;
      justify-content: center;
    }
    .half {
      width: 50%;
    }
  </style>

  <div class="modal js-modal">
    <div class="modal__bg js-modal-close"></div>
    <div class="modal__content modal_filter">
      <div class="modal__content_inner">
        <h2 class="modal_title">解析元の特徴的な表現（キーフレーズ）</h2>
        <div class="wrap">
          <word-cloud
            class="half"
            data="{ state.status ? props.keyphrase : [] }"
            width="{ $('.half').clientWidth }"
            height="{ $('.half').clientWidth*3/4 }"
          ></word-cloud>

          <radar-chart
            class="half"
            data="{ state.status ? props.radar : [] }"
            width="{ $('.half').clientWidth }"
            height="{ $('.half').clientWidth }"
          ></radar-chart>
        </div>
        <radar-chart></radar-chart>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ onClose }" style="cursor:pointer">
        <img src="/assets/img/common/icn_close_modal.svg" alt="閉じる" />
      </a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import wordCloud from "@tags/parts/word-cloud.riot";
    import radarChart from "@tags/parts/radar-chart.riot";

    export default {
      components: {
        "word-cloud": wordCloud,
        "radar-chart": radarChart,
      },
      state: {
        status: false,
      },
      onUpdated(props, state) {
        if (props.status != state.status) {
          state.status = props.status;
          const self = this;
          if (props.status) {
            window.$(this.$(`.js-modal`)).fadeIn(100, function () {
              self.onShow();
            });
          } else {
            window.$(this.$(`.js-modal`)).fadeOut(100, function () {
              self.onHide();
            });
          }
        }
      },
      onShow() {
        this.update();
      },
      onHide() {
        this.update();
      },
      onClose(e) {
        this.props.onClose ? this.props.onClose(e) : "";
      },
    };
  </script>
</keyphrase-modal>
